import React, { type ReactNode } from "react";

import styled from "styled-components";
import {
  LoadingSpinnerIcon,
  StyledLoadingSpinnerIcon,
} from "components/icons/LoadingSpinnerIcon";

export const StyledLoader = styled.div`
  color: ${(props) => props.theme.colors.uiDark};
  display: grid;

  ${StyledLoadingSpinnerIcon} {
    margin: auto;
  }
`;

interface ILoaderProps {
  children?: ReactNode;
}

function Loader({ children }: ILoaderProps) {
  return (
    <StyledLoader role="status">
      <LoadingSpinnerIcon size="40px" />
      {children}
    </StyledLoader>
  );
}

export default Loader;
